// Packages
import { useEffect, useLayoutEffect } from "react"
import PropTypes from "prop-types"
import domUtil from "lib/dom/dom-util"

// Components

// Actions

const bodyRef = domUtil.findFirst("body", null)

function PageWrapper({ disableDefaultTheme, bodyTheme, children }) {
  useLayoutEffect(() => {
    if (disableDefaultTheme) {
      domUtil.addClass(bodyRef, bodyTheme)
    } else {
      // Clear all the previous classes and always set these 2 - Default and PageBody Class
      domUtil.removeAllClasses(bodyRef)
      domUtil.addClass(bodyRef, "default")
      domUtil.addClass(bodyRef, bodyTheme)
    }
  })

  useEffect(() => {
    const { Yo } = window
    if (Yo) {
      Yo.pubsub.publish({
        topic: "rum/spa/rendered",
        message: {
          viewType: "TRANSITION",
          pageType: "CAT",
        },
      })
    }
  })

  return <div className="PageWrapper">{children}</div>
}

PageWrapper.propTypes = {
  children: PropTypes.any,
  disableDefaultTheme: PropTypes.bool,
  bodyTheme: PropTypes.string,
}

export default PageWrapper
